module.exports = __webpack_public_path__ + "img/btn-return.3d12a4ac.png";